<div class="my-4 mx-5">
    <div class="wrapper mb-5">
        <div class="row align-items-center m-0" style="padding: 10px;">
            <img class="p-2" src="./assets/icons/arrow.svg">
            <span class="label-title ml-2 mr-3">Transferência de Créditos</span>
        </div>
        <div class="component-box container-fluid mb-0">
            <div class="container-fluid pt-4">
                <div class="row">
                    <div class="col-12 text-left">
                        <ul class="options-cadastro pl-0">
                            <li>
                                <h5>Estes são os produtos do favorecido: <span class="bold"> {{
                                    colaborador?.nome }} {{ colaborador?.sobrenome }} </span></h5>
                            </li>
                        </ul>
                    </div>
                    <div class="col-12">
                        <div class="table-responsive">
                            <table class="list-table table table-striped" id="dataTable" width="100%" cellspacing="0" *ngIf="true">
                                <thead>
                                    <th>Produto</th>
                                    <th>Categoria do Produto</th>
                                    <th>Valor</th>
                                    <th>Status</th>
                                    <th></th>
                                </thead>
                                <tbody class="list-table-row">
                                    <tr class="list-table-cell" *ngFor="let product of collaboratorDetailsModel?.currentProduct">
                                        <td> {{ product?.nomeBeneficio }} </td>
                                        <td> {{ product?.produtoCategoriaDescricao }} </td>
                                        <td> {{ (product?.valorBeneficio <=0 ) ? 'R$ 0,00' : product?.valorBeneficio | currency:'BRL':true}} </td>
                                        <td> {{ product?.ativo ? 'Ativo' : 'Inativo' }} </td>
                                        <td>
                                            <div ngbDropdown class="d-inline-block menu-option" placement="left">
                                                <button class="dropdown-button" id="dropdown-menu" ngbDropdownToggle><img src="assets/icons/menu.png" /></button>
                                                <div ngbDropdownMenu aria-labelledby="dropdown-menu" class="p-0 m-0">
                                                    <section class="custom-context-menu">
                                                        <div ngbDropdownItem (click)="ShowModal(modalResgatarBeneficio,product)">
                                                            <img src="assets/icons/pencil-purple.png" class="mr-2" /> Transferir crédito
                                                        </div>
                                                    </section>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <div
                                *ngIf="collaboratorDetailsModel?.currentProduct.length === 0"
                                class="text-center"
                            >
                                <h6>
                                    Nenhuma intenção de depósito carregada. Faça uma
                                    busca para retornar a lista de intenções de depósito
                                    ou faça uma inteção de depósito.
                                </h6>
                            </div>
                            <!-- <div class="page-custom mt-2">
                                <pagination-controls
                                    (pageChange)="pageChanged($event)"
                                    responsive="true"
                                    previousLabel=""
                                    nextLabel=""
                                ></pagination-controls>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="component-box container-fluid">
            <div class="container-fluid pt-4">
                <!-- <div class="row">
                    <div class="col-md-3 text-left">
                        <ul class="options-cadastro pl-0">
                            <li>
                                <h5>Pagamentos</h5>
                            </li>
                            <li class="list-select ml-2 my-1">
                                <button class="list-select" type="button" (click)="pageChanged(1)">
                                    <img src="assets/icons/update-arrow.svg" style="height: 15px;">
                                    Atualizar
                                </button>
                            </li>
                        </ul>
                    </div>
                    <div class="col-md-9 text-right" *ngIf="true">
                        <ul class="options-cadastro">
                            <li>
                                <div *ngIf="exibirFiltro && filtroOn" (click)="deleteFilter(filtro)" class="list-select ml-2
                                    my-1">
                                    <button class="list-select-delete" type="button">
                                        Apagar filtro
                                    </button>
                                </div>
                            </li>
                            <li>
                                <div *ngIf="exibirFiltro" (click)="showFilter(filtro)" class="list-select ml-2
                                    my-1">
                                    <button class="list-select"  type="button">
                                        <span *ngIf="!filtroOn"><img src="assets/icons/filter.svg" style="height: 15px;"> Aplicar filtro</span>
                                        <span *ngIf="filtroOn"><img src="assets/icons/filter-purple.svg" style="height: 15px;"> Alterar filtro</span>
                                    </button>
                                </div>
                            </li>
                            <li>
                                <div class="list-select-search-input ml-2 my-1">
                                    <input class="w-100 ng-untouched ng-pristine
                                        ng-valid" placeholder="Pesquise aqui..." type="search" [(ngModel)]="filtroPesquisa" (keyup.enter)="pageChanged(1)" />
                                </div>
                            </li>
                            <li>
                                <div class="list-filter-show-item ml-2 my-1">
                                    Mostrar:
                                    <select (change)="showItemChanged($event.target.value)" class="ng-untouched ng-pristine ng-valid">
                                        <option _ selected="" value="10">10</option>
                                        <option value="25">25</option>
                                        <option value="50">50</option>
                                        <option value="100">100</option>
                                    </select>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div> -->

                <div class="row">
                    <div class="col-12 text-left">
                        <ul class="options-cadastro pl-0">
                            <li>
                                <h5>Histórico</h5>
                            </li>
                        </ul>
                    </div>
                    <div class="col-12">
                        <div class="table-responsive">
                            <table class="list-table table table-striped" id="dataTable" width="100%" cellspacing="0" *ngIf="true">
                                <thead>
                                    <th>Produto Origem</th>
                                    <th>Produto Destino</th>
                                    <th>Valor</th>
                                    <th>Data do Resgate</th>
                                    <th>Gestor Responsável</th>
                                </thead>
                                <tbody class="list-table-row">
                                    <tr class="list-table-cell" *ngFor="let transferencia of historicoTransferencia">
                                        <td>{{ transferencia.nomeProdutoOrigem }}</td>
                                        <td>{{ transferencia.nomeProdutoDestino }}</td>
                                        <td>{{ transferencia.valor | currency:'BRL':true}}</td>
                                        <td>{{ transferencia.dataResgate | date: "dd/MM/yyyy HH:mm" }}</td>
                                        <td>{{ transferencia.nomeGestorResponsavel }}</td>
                                    </tr>
                                </tbody>
                            </table>

                            <div
                                *ngIf="collaboratorDetailsModel?.currentProduct.length === 0"
                                class="text-center"
                            >
                                <h6>
                                    Nenhuma intenção de depósito carregada. Faça uma
                                    busca para retornar a lista de intenções de depósito
                                    ou faça uma inteção de depósito.
                                </h6>
                            </div>
                            <!-- <div class="page-custom mt-2">
                                <pagination-controls
                                    (pageChange)="pageChanged($event)"
                                    responsive="true"
                                    previousLabel=""
                                    nextLabel=""
                                ></pagination-controls>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- <div class="container-fluid">
    <div class="row">
        <div class="col-9 rm-padding">
            <span class="list-header-title">Transferência de Créditos</span>
        </div>
        <div class="col-3 text-right rm-padding">
            <button class="custom-button-back" (click)="goToBack()">
                Voltar
            </button>
        </div>
    </div>
</div>

<div class="container-fluid col-12">

    <div class="row">
        <p>Estes são os produtos do favorecido: <span class="bold"> {{
                colaborador?.nome }} {{ colaborador?.sobrenome }} </span></p>
    </div>



    <div class="row">
        <div class="list-box col-12">
            <table class="list-table table table-striped">
                <thead class="list-table-head">
                    <th>Produtos</th>
                    <th>Valor</th>
                    <th>Status</th>
                    <th></th>
                </thead>
                <tbody class="list-table-row">
                    <tr class="list-table-cell" *ngFor="let product of collaboratorDetailsModel?.currentProduct">
                        <td> {{ product?.nomeBeneficio }} </td>
                        <td> {{ (product?.valorBeneficio
                            <=0 ) ? 'R$ 0,00' : product?.valorBeneficio | currency:'BRL':true}} </td>

                                <td> Ativo </td>
                                <td>
                                    <div ngbDropdown class="d-inline-block
                                    menu-option">
                                        <button class="dropdown-button" id="dropdown-menu" ngbDropdownToggle>
                                    <img src="assets/icons/menu.png" /></button>
                                        <div ngbDropdownMenu aria-labelledby="dropdown-menu" class="p-0 m-0">
                                            <section class="custom-context-menu">
                                                <div ngbDropdownItem (click)="ShowModal(modalResgatarBeneficio,product)">
                                                    <img src="assets/icons/pencil-purple.png" class="mr-2" /> Transferir crédito
                                                </div>
                                            </section>
                                        </div>
                                    </div>
                                </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <div class="row mt-5">
        <h5>Histórico :</h5>
    </div>

    <div class="row">
        <div class="table-responsive">
            <table class="table table-bordered table-striped" id="dataTable" width="100%" cellspacing="0">
                <thead class="list-table-head b-t-custom">
                    <th>Produto Origem</th>
                    <th>Produto Destino</th>
                    <th>Valor</th>
                    <th>Data do Resgate</th>
                    <th>Gestor Responsável</th>
                </thead>
                <tbody>
                    <tr class="list-table-row" *ngFor="let transferencia of historicoTransferencia">
                        <td>{{ transferencia.nomeProdutoOrigem }}</td>
                        <td>{{ transferencia.nomeProdutoDestino }}</td>
                        <td>{{ transferencia.valor | currency:'BRL':true}}</td>
                        <td>{{ transferencia.dataResgate | date: "dd/MM/yyyy HH:mm" }}</td>
                        <td>{{ transferencia.nomeGestorResponsavel }}</td>
                    </tr>
                </tbody>
            </table>

            <div *ngIf="historicoTransferencia.length == 0" class="text-center">
                <h6>
                    Nenhuma transferência realizada
                </h6>
            </div>

        </div>
    </div>
</div> -->

<!-- <ng-template #modalResgatarBeneficio let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="modal-title clean-modal-title">
                Transferência de créditos
            </h5>
            <p class="clean-modal-subtitle" *ngIf="beneficioValorSelecionado.valorBeneficio > 0 && qtdBeneficio > 0">
                Qual o valor que gostaria de transferir da conta {{ beneficioValorSelecionado.nomeBeneficio }}?
            </p>
        </div>
    </div>

    <div class="col-12 clean-modal-content">
        <div class="clean-modal-text">
            <form *ngIf="beneficioValorSelecionado.valorBeneficio > 0 && qtdBeneficio > 0">
                <div class="form-group">
                    <div class="clean-modal-section-title">Digite o valor</div>

                    <input type="text" class="w-75" #valor currencyMask [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }" (keypress)="ClearMessage()" />

                    <span class="legend">
                        O saldo disponível para transferência é de {{ beneficioValorSelecionado.valorBeneficio | currency:'BRL':true}}
                    </span>

                    <div class="clean-modal-section-title m-t-15p">Conta Destino</div>

                    <select class="w-75 h-30p" #contaCredito (change)="ClearMessage()">
                        <option selected value="NA">--</option>
                        <ng-container *ngFor="let product of collaboratorDetailsModel?.currentProduct">
                            <option *ngIf="product?.nomeBeneficio != beneficioValorSelecionado.nomeBeneficio
                                            && beneficioValorSelecionado.produtoCategoria == product?.produtoCategoria"
                                value="{{ product?.contaGuid }}">
                                {{ product?.nomeBeneficio }}
                            </option>
                        </ng-container>
                    </select>

                    <span class="message-error" *ngIf="mensagemValidacao">
                        {{ mensagemValidacao }}
                    </span>
                </div>
                <button class="custom-filter-button" (click)="TransferirBeneficio(valor.value, contaCredito.value)">
                    Transferir
                </button>
            </form>

            <h4 class="text-center" *ngIf="beneficioValorSelecionado?.valorBeneficio == 0"> Não existe valor para transferência </h4>
            <h4 class="text-center" *ngIf="beneficioValorSelecionado?.valorBeneficio != 0 && qtdBeneficio == 0">Crédito não pode ser transferido</h4>
        </div>
    </div>

    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button button-cancel" (click)="modal.dismiss('Close click')">
            Fechar
        </button>
    </div>
</ng-template> -->

<ng-template #modalResgatarBeneficio let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="clean-modal-title">Transferência de créditos</h5>
            <p class="clean-modal-subtitle" *ngIf="beneficioValorSelecionado?.valorBeneficio > 0 && qtdBeneficio > 0">
                Qual o valor que gostaria de transferir da conta {{ beneficioValorSelecionado.nomeBeneficio }}?
            </p>
            <p class="clean-modal-subtitle text-center">
                <small>

                </small>
            </p>
        </div>
    </div>

    <ng-container *ngIf="beneficioValorSelecionado.valorBeneficio > 0 && qtdBeneficio > 0">
        <div class="col-12 clean-modal-content">
            <div class="custom-filter-input-container d-flex justify-content-center">
                <mat-form-field class="w-75">
                    <mat-label>Digite o valor</mat-label>
                    <input [formControl]="valueCtrl" matInput type="text" currencyMask [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }">
                    <mat-hint align="start">O saldo disponível para transferência é de <strong>{{ beneficioValorSelecionado.valorBeneficio | currency:'BRL':true}}</strong> </mat-hint>
                  </mat-form-field>

                <!-- <mat-form-field class="w-75">
                    <mat-label>Digite o valor</mat-label>
                    <input [formControl]="nameCtrl" matInput type="text" #valor currencyMask [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }">
                </mat-form-field> -->
            </div>

            <div class="custom-filter-input-container d-flex justify-content-center">
                <mat-form-field class="w-75">
                    <mat-label>Conta Destino</mat-label>
                    <mat-select  [formControl]="accontCtrl" [value]="contaCredito" >
                            <ng-container  *ngFor="let product of collaboratorDetailsModel?.currentProduct">
                                <ng-container *ngIf="(!product?.transfereParaTodos && product?.recebeDeTodos)">
                                    <mat-option  *ngIf="(!product?.transfereParaTodos && product?.recebeDeTodos)
                                    && product?.nomeBeneficio != beneficioValorSelecionado.nomeBeneficio"
                                    [value]="product?.contaGuid">{{ product?.nomeBeneficio }}</mat-option>
                                </ng-container>
                                <ng-container *ngIf="(product?.transfereParaTodos && !product?.recebeDeTodos)" >
                                    <mat-option  *ngIf="(product?.transfereParaTodos && !product?.recebeDeTodos)
                                    && product?.nomeBeneficio != beneficioValorSelecionado.nomeBeneficio
                                    && beneficioValorSelecionado.produtoCategoria == product?.produtoCategoria"
                                    [value]="product?.contaGuid">{{ product?.nomeBeneficio }}</mat-option>
                                </ng-container>
                        </ng-container>
                    </mat-select>
                </mat-form-field>
            </div>
            <span class="message-error" *ngIf="mensagemValidacao">
                {{ mensagemValidacao }}
            </span>

        </div>
    </ng-container>

    <h4 class="text-center" *ngIf="beneficioValorSelecionado?.valorBeneficio == 0"> Não existe valor para transferência </h4>
    <h4 class="text-center" *ngIf="beneficioValorSelecionado?.valorBeneficio != 0 && qtdBeneficio == 0">Crédito não pode ser transferido</h4>

    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button button-cancel mr-2" (click)="modal.dismiss('Close click')" ngbAutofocus>
            Cancelar
        </button>
        <button class="custom-modal-button" type="button" (click)="TransferirBeneficio()" *ngIf="beneficioValorSelecionado?.valorBeneficio > 0 && qtdBeneficio > 0">
            Transferir
        </button>
    </div>
</ng-template>
